import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"
import ReactCookie from "react-cookie";

export default class PresentationController extends React.Component {
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    componentWillMount() {
        if (ReactCookie.load("product-view") && ReactCookie.load("product-view") !== this.props.value) {
            this.onChange(ReactCookie.load("product-view"));
        }
    }

    onChange(value) {
        let val = value;
        if (typeof this.props.options[val] === "undefined") {
            val = this.props.default;
        }
        ReactCookie.save("product-view", val, { path: "/", secure: this.props.useSecureCookie });

        this.props.onChange(this.props.options[val].view);
    }

    render() {
        const PresentationView = ComponentRegistry.get("ProductBrowserViewsPresentationView");

        const choices = {};
        let value = this.props.default;
        Object.keys(this.props.options).forEach((key) => {
            choices[key] = this.props.options[key].label;
            if (this.props.value === this.props.options[key].view) {
                value = key;
            }
        });

        return (
          <PresentationView {...this.props} choices={choices} value={value} onChange={this.onChange} />
        );
    }
}

PresentationController.propTypes = {
    options: PropTypes.objectOf(PropTypes.shape({
        view: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    })).isRequired,
    useSecureCookie: PropTypes.bool.isRequired,
    default: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
};

PresentationController.defaultProps = {
    useSecureCookie: true,
};



// WEBPACK FOOTER //
// ./src-js/Fratello/ProductBrowser/Controllers/PresentationController.jsx